export default __webpack_public_path__ + "static/hep-liver-img-2d16a807b1a0f82944fad9b5b26fe3df.jpg";